
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Attachment/Attachment.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Attachment.html');
        
        var script = require('./Attachment.ts').default;
        module.exports = require('./Attachment.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    